import { render, staticRenderFns } from "./Ofr.vue?vue&type=template&id=2a0e6e87&scoped=true&"
import script from "./Ofr.vue?vue&type=script&lang=js&"
export * from "./Ofr.vue?vue&type=script&lang=js&"
import style0 from "./Ofr.vue?vue&type=style&index=0&id=2a0e6e87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0e6e87",
  null
  
)

export default component.exports